import { c as _c } from "react/compiler-runtime";
import { useMutationState as useTanstackMutationState } from '@tanstack/react-query';
/**
 * Returns the mutation state for mutations matching the given key and status.
 *
 * @param mutationKey - The mutation key to filter by.
 * @param status - The mutation status to filter by.
 * @returns The filtered mutation state results.
 */
export function useMutationState(mutationKey, status) {
  const $ = _c(3);
  let t0;
  if ($[0] !== mutationKey || $[1] !== status) {
    t0 = {
      filters: {
        mutationKey,
        status
      },
      select: _temp
    };
    $[0] = mutationKey;
    $[1] = status;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return useTanstackMutationState(t0);
}
function _temp(mutation) {
  return mutation.state;
}